import { useState } from "react";

import { useAuth } from "../context/AuthContext";
import { CONTENT_REPORT_REASONS, reportContent } from "../services/safetyService";

export default function DropReportAction({ dropId, creatorName, onReported, onError }) {
  const { currentUser } = useAuth();
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);

  if (!currentUser || !dropId) return null;

  const handleReport = async (reason) => {
    if (busy) return;
    setBusy(true);
    try {
      await reportContent({
        reporterId: currentUser.uid,
        targetType: "drop",
        targetId: dropId,
        targetUsername: creatorName || "",
        reason,
      });
      setOpen(false);
      onReported?.();
    } catch (err) {
      console.error("Drop report error:", err);
      onError?.(err);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="dv-drop-report">
      <button
        type="button"
        className="dv-drop-report-btn"
        onClick={() => setOpen((prev) => !prev)}
        aria-expanded={open}
      >
        Report this drop
      </button>
      {open && (
        <div className="dv-c-report-row show">
          <span className="dv-c-report-label">Why are you reporting?</span>
          <div className="dv-c-report-reasons">
            {CONTENT_REPORT_REASONS.map((reason) => (
              <button
                key={reason}
                type="button"
                className="dv-c-report-reason"
                disabled={busy}
                onClick={() => handleReport(reason)}
              >
                {reason}
              </button>
            ))}
          </div>
          <button
            type="button"
            className="dv-c-confirm-btn dv-c-confirm-no"
            onClick={() => setOpen(false)}
            disabled={busy}
          >
            Cancel
          </button>
        </div>
      )}
    </div>
  );
}
